//
import { mapActions, mapState } from 'vuex'
import { ModelForm } from '@/components/reusable_components/next'

//
import OrdererModel from '@/models/Warehouse/WhOrderer'
import Translator from '@/services/translator'
import fields from './fields'

//
export default {
    name: 'dispatch-requests-update',
    components: {
        ModelForm,
    },
    computed: {
        //
        ...mapState('AuthModule', ['user']),

        /**
         *
         */
        formProps() {
            return {
                editable: false,
                fields: fields({
                    g_branch_office_id: this.user.hr_employee
                        .g_branch_office_id,
                    g_branch_office_selected_id: this.branchOfficeId,
                    pch_provider_id: this.formData.pch_provider_id,
                    triggerWarehouse: this.changeWarehouseFilter,
                }),
                loading: this.busy,
                switchEdit: ! this.formData.was_processed,
            }
        },
    },
    data() {
        return {
            branchOfficeId: 1,
            busy: false,
            formData: {},
        }
    },
    methods: {
        //
        ...mapActions('MenuesModule', {
            setTitleTopBar: 'setTitleTopBar',
        }),

        //
        ...mapActions('SnackbarModalModule', {
            initSnackbar: 'initSnackbar',
            hideSnack: 'hideSnack',
            resetSnackbarState: 'resetSnackbarState',
            setMessageConfirmSnack: 'setMessageConfirmSnack',
        }),

        /**
         *
         */
        changeWarehouseFilter(ctx) {
            this.branchOfficeId =
                ctx.getInput('of_warehouse').getSelected().g_branch_office_id ||
                this.user.hr_employee.g_branch_office_id
        },

        /**
         *
         */
        fetch() {
            OrdererModel.modeler()
                .find(this.$route.params.id)
                .then(this.setFormData)
        },

        /**
         *
         */
        redirect() {
            this.$router.push({ name: 'orderer' })
        },

        /**
         *
         */
        reset() {
            this.fetch()
            this.toggleBusy()
        },

        /**
         *
         */
        setFormData(model) {
            this.branchOfficeId = this.user.hr_employee.g_branch_office_id
            this.busy = false
            this.formData = model.clone().reset()
        },

        /**
         *
         */
        showError(error) {
            this.showSnackbar(
                'error',
                'Error.',
                Translator(OrdererModel, error.response.data)
            )
        },

        /**
         *
         */
        showSnackbar(type, title, message, callback) {
            this.initSnackbar(this.fillSnack(type, title, message))
            if (typeof callback === 'function') callback()
        },

        /**
         *
         */
        showSuccess() {
            this.showSnackbar(
                'success',
                'Éxito.',
                'Solicitud de abastecimiento actualizada.',
                this.redirect
            )
        },

        /**
         *
         */
        submit() {
            this.$refs.form.setWait(true).then(this.update)
        },

        /**
         *
         */
        toggleBusy() {
            this.busy = !this.busy
        },

        /**
         *
         */
        update(model) {
            model
                .update()
                .then(this.showSuccess)
                .catch(this.showError)
                .then(this.$refs.form.setWait)
        },
    },
    beforeMount() {
        this.setTitleTopBar('Datos la solicitud de abastecimiento')
    },
    mounted() {
        this.reset()
    },
}
